// extracted by mini-css-extract-plugin
export default {"container":"SidingAccent_container__2B9l7","productListContainer":"SidingAccent_productListContainer__8maaY","productGrid":"SidingAccent_productGrid__If8qD"};